export function setCookie(cookieName, value, daysToExpire = 180) {
  let date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie = `${cookieName}=${value}; path=/; expires=${date.toUTCString()} `;
}

export function getCookie(name) {
  if (document) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
  }
}

export function getAllCookies() {
  const cookies = document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});

  return cookies;
}

export function deleteCookie(cookieName) {
  //Cookies don't use the subdomain in the name, so we only want to include up to two pieces
  // (This also works for localhost)
  const domainName = location.hostname.split(".").slice(-2).join(".");
  document.cookie = `${cookieName}=; expires=${new Date(
    0
  ).toUTCString()};path=/; domain=${domainName}`;
}
